import API from "../config/api";

const BASE = "catalogo_cuenta";

export function findAllcatalogoCuenta() {
    return API.get(`${BASE}`)
}